import React from 'react';
import { Pressable, StyleSheet, Text, View } from 'react-native';

const SUB_STATE_TITLES = {
  idle: 'Your subscription',
  cancel_confirm: 'Cancel subscription',
  switch_preview: 'Review the change',
  switch_confirm: 'Confirm plan switch',
  post_success: 'All set',
  error: 'Something went wrong',
  portal_return_flash: 'Welcome back',
};

export default function BillingModalHeader({ subState = 'idle', status, onClose }) {
  const title = SUB_STATE_TITLES[subState] ?? SUB_STATE_TITLES.idle;
  return (
    <View style={styles.root}>
      <Text style={styles.title}>{title}</Text>
      <Pressable
        onPress={onClose}
        accessibilityLabel="Close billing modal"
        accessibilityRole="button"
        style={({ pressed }) => [styles.closeBtn, pressed && { opacity: 0.6 }]}
      >
        <Text style={styles.closeX}>×</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    paddingTop: 18,
    paddingBottom: 12,
    borderBottomWidth: 1,
    borderBottomColor: 'rgba(255,255,255,0.08)',
  },
  title: { fontSize: 18, fontWeight: '600', color: '#FFFFFF' },
  closeBtn: {
    width: 32, height: 32, alignItems: 'center', justifyContent: 'center',
    borderRadius: 16,
  },
  closeX: { fontSize: 28, lineHeight: 28, color: 'rgba(255,255,255,0.6)' },
});
